import React, { Children } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export function ReservationDetail() {
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 Nov 2025',
      checkOut: '11 Nov 2025',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.my',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Maldivan escape early and enjoy the added luxury of a complimentary round-trip seaplane transfer from Malé to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: '$1.00',
      serviceCharge: '$0.10'
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-8081">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-8082">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-8083">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-8084" />
          <span data-id="element-8085">Reservation Details</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-8086">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-8087">
          <div className="flex justify-between items-center" data-id="element-8088">
            <h2 className="text-xl font-bold" data-id="element-8089">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-8090">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-8091">
                Confirmed
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-8092">
                Resend confirmation email
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-8093">
          <div className="p-6 border-r border-gray-200" data-id="element-8094">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-8095">Date</h3>
            <p className="text-gray-900 font-medium" data-id="element-8096">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-8097">
              {reservation.date.nights} Nights
            </p>
          </div>
          <div className="p-6" data-id="element-8098">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-8099">
              Guests & Rooms
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-8100">
              {reservation.guests.adults} Adults, {reservation.guests.children}{' '}
              Children, {reservation.guests.infants} Infants
            </p>
            <p className="text-sm text-gray-500" data-id="element-8101">
              {reservation.guests.rooms} Room
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8102">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8103">Booking Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8104">
            <div data-id="element-8105">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8106">Booking ID</p>
              <p className="text-sm text-gray-900" data-id="element-8107">{reservation.booking.id}</p>
            </div>
            <div data-id="element-8108">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8109">Transaction ID</p>
              <p className="text-sm text-gray-900" data-id="element-8110">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8111">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8112">Hotel</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8113">
            <div data-id="element-8114">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8115">Name</p>
              <p className="text-sm text-gray-900" data-id="element-8116">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-8117">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8118">Hotel ID</p>
              <p className="text-sm text-gray-900" data-id="element-8119">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8120">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8121">Room Type</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-8122">
            <div data-id="element-8123">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8124">Name</p>
              <p className="text-sm text-gray-900" data-id="element-8125">{reservation.room.name}</p>
            </div>
            <div data-id="element-8126">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8127">View</p>
              <p className="text-sm text-gray-900" data-id="element-8128">{reservation.room.view}</p>
            </div>
            <div data-id="element-8129">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8130">Category</p>
              <p className="text-sm text-gray-900" data-id="element-8131">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-8132">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8133">Guest Information</h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-8134">
            <h4 className="text-base font-medium mb-4" data-id="element-8135">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8136">
              <div data-id="element-8137">
                <p className="text-sm text-gray-500 mb-1" data-id="element-8138">Email</p>
                <p className="text-sm text-gray-900" data-id="element-8139">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-8140">
                <p className="text-sm text-gray-500 mb-1" data-id="element-8141">Phone number</p>
                <p className="text-sm text-gray-900" data-id="element-8142">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-8143">
                <p className="text-sm text-gray-500 mb-1" data-id="element-8144">Passport number</p>
                <p className="text-sm text-gray-900" data-id="element-8145">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-8146">
                <p className="text-sm text-gray-500 mb-1" data-id="element-8147">Date of birth</p>
                <p className="text-sm text-gray-900" data-id="element-8148">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-8149">
                <p className="text-sm text-gray-500 mb-1" data-id="element-8150">Nationality</p>
                <p className="text-sm text-gray-900" data-id="element-8151">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-8152">
                <p className="text-sm text-gray-500 mb-1" data-id="element-8153">Special Requests</p>
                <p className="text-sm text-gray-900" data-id="element-8154">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-8155">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8156">Rate Details</h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-8157">
            <div data-id="element-8158">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8159">Rate Name</p>
              <p className="text-sm text-gray-900" data-id="element-8160">{reservation.rate.name}</p>
            </div>
            <div data-id="element-8161">
              <p className="text-sm text-gray-500 mb-1" data-id="element-8162">Description</p>
              <p className="text-sm text-gray-900" data-id="element-8163">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-8164">
          <h3 className="text-sm font-semibold mb-4" data-id="element-8165">Price Breakdown</h3>
          <div className="space-y-3" data-id="element-8166">
            <div className="flex justify-between" data-id="element-8167">
              <p className="text-sm text-gray-500" data-id="element-8168">Subtotal</p>
              <p className="text-sm text-gray-900" data-id="element-8169">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-8170">
              <p className="text-sm text-gray-500" data-id="element-8171">Service charge</p>
              <p className="text-sm text-gray-900" data-id="element-8172">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-8173">
              <p className="text-sm font-medium" data-id="element-8174">Total</p>
              <p className="text-sm font-bold" data-id="element-8175">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}